var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "suporte-card d-flex align-center",
      class: { "suporte-card--compacto": _vm.compacto },
      attrs: {
        href: _vm.link,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-test": "suporte-whatsapp-card"
      }
    },
    [
      _c("icon-svg", {
        staticClass: "flex-shrink-0",
        attrs: {
          name: "whatsapp",
          size: _vm.compacto ? 14 : 16,
          color: _vm.corDaMarca
        }
      }),
      _c("span", { staticClass: "suporte-card__texto d-flex flex-column" }, [
        _c("span", { staticClass: "suporte-card__chamada ia-texto-micro" }, [
          _vm._v(_vm._s(_vm.suporte.chamada))
        ]),
        _c("span", { staticClass: "suporte-card__nome ia-texto-auxiliar" }, [
          _vm._v(_vm._s(_vm.suporte.rotulo))
        ])
      ]),
      _c("icon-svg", {
        staticClass: "suporte-card__chevron flex-shrink-0 ml-auto",
        attrs: { name: "chevron-right", size: 12, color: "var(--neutral-600)" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }